module.exports = __webpack_public_path__ + "static/media/Table-chevron-left.d98d6dc1.svg";